import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SsoAuthenticationService {
  private readonly tokenName = 'team-benefits-sso-token';

  private _isAuthenticatedSubject: BehaviorSubject<boolean>;

  public isAuthenticated$: Observable<boolean>;

  constructor() {
    this._isAuthenticatedSubject = new BehaviorSubject<boolean>(this.isLoggedIn());
    this.isAuthenticated$ = this._isAuthenticatedSubject.asObservable();
  }

  public isLoggedIn(): boolean {
    return !!localStorage.getItem(this.tokenName);
  }

  public storeToken(token: string): void {
    localStorage.setItem(this.tokenName, token);
    this._isAuthenticatedSubject.next(true);
  }

  public deleteToken(): void {
    localStorage.removeItem(this.tokenName);
    this._isAuthenticatedSubject.next(false);
  }

  public getAccessToken(): string | null {
    return localStorage.getItem(this.tokenName);
  }
}
